import { render, staticRenderFns } from "./FichaConservacao.vue?vue&type=template&id=4fcbe05b&"
import script from "./FichaConservacao.vue?vue&type=script&lang=js&"
export * from "./FichaConservacao.vue?vue&type=script&lang=js&"
import style0 from "./FichaConservacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports